import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface AssinaturaDto {
  id: string;
  fornecedor: { id: string; nome: string };
  planLevel: string;
  vitrineSinceDate?: string;
  proximoVencimento?: string;
  subscriptionExpiresAt?: string;
  diasParaVencimento?: number;
  status: string;
  paymentStatus?: string;
  paymentMethod?: string;
  autoRenew?: boolean;
  ativo?: boolean;
  isClaimed?: boolean;
  leadCount?: number;
  valor?: number;
  valorMensal?: number;
}

@Injectable({ providedIn: 'root' })
export class FinanceiroService {
  constructor(private api: ApiService) {}

  listarAssinaturas(params: { status?: string; dias?: number; page?: number; pageSize?: number } = {}): Observable<{ data: AssinaturaDto[]; meta: any }> {
    const p = { page: 1, pageSize: 20, ...(params || {}) };
    return this.api.get('/admin/financeiro/assinaturas', p) as Observable<any>;
  }

  registrarPagamento(payload: {
    fornecedorId: string;
    valor: number;
    metodoPagamento: string;
    dataRecebimento: string;
    comprovante?: string;
    observacoes?: string;
  }): Observable<any> {
    return this.api.post('/admin/financeiro/registrar-pagamento', payload);
  }

  listarHistorico(params: { page?: number; pageSize?: number } = {}): Observable<{ data: any[]; meta: any }> {
    const p = { page: 1, pageSize: 20, ...(params || {}) };
    return this.api.get('/admin/financeiro/historico', p) as Observable<any>;
  }
}
